/* jshint esnext: true */

const map = {

	route: [],

	map: [],
	tiles: [],

	canvas: null,

	ctx: null,

	checkpoints: {},

	tileImage: null,

	defaultTile: 32,


	tileLookup: {
		// 4 key directions.
		2: 1, // right.
		4: 4, // left.
		8: 9, // down.
		16: 24, // up.

		// Blended directions.
		10: 6,
		12: 8,
		14: 7,
		18: 16,
		20: 18,
		22: 17,
		26: 11,
		28: 13,
		30: 12,

		// Start and end.
		64: 26,
		128: 31
	},

	// Directions to check (East, West, South, North).
	directions: [
		[ 1, 0, 2, 4 ],
		[ -1, 0, 4, 2 ],
		[ 0, 1, 8, 16 ],
		[ 0, -1, 16, 8 ]
	],


	/**
	 * Generate a map.
	 */
	generate: function() {

		// Quit if the tileset is not set.
		if ( !tilesets[ settings.tileset ] ) {
			return;
		}

		let tiles = tilesets[ settings.tileset ];
		let content = document.querySelector( '.content' );

		this.tileImage = document.createElement( 'img' );
		this.tileImage.src = '/assets/images/maze' + settings.tileset + '.png';

		content.style.background = '#' + tiles[ 1 ];

		const contentClass = content.classList;
		contentClass.remove( 'dark', 'light' );
		contentClass.add( tiles[ 2 ] );

		this.init();
		this.design();

		// Draw the tiles.
		// this.draw();
		this.tileImage.onload = () => this.draw();

	},


	design: function() {

		this.initMap();

		this.addStartEnd();
		this.addIslands();
		// this.addMonuments();

		this.loop();

		// Adds links on top of the generated map.
		this.addLinks();
		this.addRoundabouts();

		// Add Monuments
		// Add Roundabouts
		// Add Bridges
		// Add Links

	},


	/**
	 *
	 */
	addMonuments: function() {

		// let totalArea = settings.width * settings.height;
		// let monumentCount = Math.ceil( totalArea / 300 );

	},


	/**
	 * Add roundabouts (circles with a hole in the middle).
	 */
	addRoundabouts: function() {

		let totalArea = settings.width * settings.height;
		let count = Math.ceil( totalArea / 100 );
		let border = 4;

		for ( let i = 0; i < count; i++ ) {

			let x = rando.range( border, settings.width - border );
			let y = rando.range( border, settings.height - border );

			if ( this.defaultTile !== this.map[ y ][ x ] ) {

				// 2: 1, // right.
				// 4: 4, // left.
				// 8: 9, // down.
				// 16: 24, // up.

				// Row 1.
				this.addPath( x, y, 2 );
				this.addPath( x, y, 8 );

				this.addPath( x + 1, y, 2 );
				this.addPath( x + 1, y, 4 );
				this.removePath( x + 1, y, 8 )

				this.addPath( x + 2, y, 4 );
				this.addPath( x + 2, y, 8 );

				// Row 2.
				this.addPath( x, y + 1, 8 );
				this.addPath( x, y + 1, 16 );
				this.removePath( x, y + 1, 2 )

				// Middle.
				this.map[ y + 1 ][ x + 1 ] = this.defaultTile;

				this.addPath( x + 2, y + 1, 8 );
				this.addPath( x + 2, y + 1, 16 );
				this.removePath( x + 2, y + 1, 4 )

				// Row 3.
				this.addPath( x, y + 2, 2 );
				this.addPath( x, y + 2, 16 );

				this.addPath( x + 1, y + 2, 2 );
				this.addPath( x + 1, y + 2, 4 );
				this.removePath( x + 1, y + 2, 16 )

				this.addPath( x + 2, y + 2, 4 );
				this.addPath( x + 2, y + 2, 16 );

			}

		}

	},


	/**
	 * Add links between paths.
	 */
	addLinks: function() {

		let totalArea = settings.width * settings.height;
		let count = Math.ceil( totalArea / 8 );
		let border = 2;

		for ( let i = 0; i < count; i++ ) {

			let x = rando.range( border, settings.width - border );
			let y = rando.range( border, settings.height - border - 1 );

			if ( this.defaultTile !== this.map[ y ][ x ] ) {

				let direction = this.directions[ rando.range( 0, this.directions.length - 1 ) ];

				this.addPath( x, y, direction[ 2 ] );
				this.addPath( direction[ 0 ] + x, direction[ 1 ] + y, direction[ 3 ] );

			}

		}

	},


	/**
	 * Add a path (exit) to the current tile.
	 * Ensures it has not already been added, so that we don't end up with strange tile values.
	 *
	 * @param {number} x X tile.
	 * @param {number} y Y tile.
	 * @param {number} direction Value representing the direction to add to the specified tile.
	 */
	addPath: function( x, y, direction ) {

		if ( this.defaultTile === this.map[ y ][ x ] ) {
			this.map[ y ][ x ] = direction;
		} else if ( direction !== ( this.map[ y ][ x ] & direction ) ) {
			this.map[ y ][ x ] += direction;
		}

	},


	/**
	 * Remove a path (exit) from the specified tile.
	 * Ensures that the specified tile has the exit direction specified before removing.
	 *
	 * @param {number} x X tile.
	 * @param {number} y Y tile.
	 * @param {number} direction Value representing the direction to remove from the specified tile.
	 */
	removePath: function( x, y, direction ) {

		if ( direction === ( this.map[ y ][ x ] & direction ) ) {
			this.map[ y ][ x ] -= direction;
		}

	},


	/**
	 * Add the start and end points.
	 */
	addStartEnd: function() {

		for ( let i = 0; i < settings.width; i++ ) {

			this.map[ 0 ][ i ] = this.defaultTile;
			this.map[ settings.height - 1 ][ i ] = this.defaultTile;

		}

		let startX = 0;

		// Start position.
		startX = rando.range( 1, settings.width - 1 - 1 );

		this.map[ 0 ][ startX ] = 0;
		// Set the start as the first step in the journey.
		this.route.push( [ startX, 0 ] );

		// End position.
		let endX = rando.range( 1, settings.width - 1 - 1 );
		this.map[ settings.height - 1 ][ endX ] = 0;

		this.checkpoints = {
			start: startX,
			end: endX
		};

	},


	/**
	 * Add islands of land to break up the maze into more interesting shapes.
	 */
	addIslands: function() {

		let totalArea = settings.width * settings.height;
		let desiredArea = Math.ceil( totalArea * settings.islandArea );
		let count = 0;
		let border = 1;

		while ( true ) {

			let size = rando.range( 1, 3 );
			let x = rando.range( border, settings.width - size - border );
			let y = rando.range( border + 2, settings.height - size - border - 2 );

			for ( let i = 0; i < size; i++ ) {
				for ( let j = 0; j < size; j++ ) {

					if ( 'undefined' !== typeof this.map[ y + i ][ x + j ] ) {
						this.map[ y + i ][ x + j ] = this.defaultTile;
					}

				}
			}

			count += ( size * size );

			if ( count > desiredArea ) {
				break;
			}
		}

	},


	/**
	 * Initialize the drawing settings.
	 */
	init: function() {

		this.canvas = document.querySelector( 'canvas' );
		this.ctx = this.canvas.getContext( '2d' );

		settings.x = 0;
		settings.y = 0;

		// Set canvas size.
		this.canvas.width = settings.width * settings.tileWidth;
		this.canvas.height = settings.height * settings.tileWidth;

		this.initMap();

	},


	/**
	 *
	 */
	initMap: function() {

		// Reset map and tile properties.
		this.map = [];
		this.tiles = [];

		// Initialize size of array and set everything to 0 to show it's not in use.
		for ( let i = 0; i < settings.height; i++ ) {

			this.map[ i ] = [];
			this.tiles[ i ] = [];

			for ( let j = 0; j < settings.width; j++ ) {
				this.map[ i ][ j ] = 0;
				this.tiles[ i ][ j ] = 0;
			}

		}

		// Set the start point.
		this.route = [];

		this.directions = shuffle( this.directions );

	},


	/**
	 * Generate the map paths.
	 */
	loop: function() {

		// Set the current position.
		settings.x = this.route[ this.route.length - 1 ][ 0 ];
		settings.y = this.route[ this.route.length - 1 ][ 1 ];

		// Create a list of alternatives.
		let alternatives = [];

		// Loop through the directions.
		for ( let i = 0; i < this.directions.length; i++ ) {

			let x = this.directions[ i ][ 0 ] + settings.x;
			let y = this.directions[ i ][ 1 ] + settings.y;

			if (
				undefined !== this.map[ y ] &&
				0 === this.map[ y ][ x ]
			) {

				// Add it to the list of alternatives.
				alternatives.push( this.directions[ i ] );

			}

		}

		// If there's no options then it's the end of the current path, so lets look for another route.
		if ( 0 === alternatives.length ) {

			this.route.pop();

			if ( this.route.length > 0 ) {
				this.loop();
			}

			return;

		}

		alternatives = shuffle( alternatives );

		// Which direction should we move in.
		let new_direction = rando.range( 0, alternatives.length - 1 );

		// Pick a random direction from the alternatives.
		let direction = alternatives[ new_direction ];

		// Add the new tile as the next path.
		this.route.push( [ direction[ 0 ] + settings.x, direction[ 1 ] + settings.y ] );

		// Save the current wall as blocked.
		// this.map[ settings.y ][ settings.x ] += direction[ 2 ];
		// this.map[ direction[ 1 ] + settings.y ][ direction[ 0 ] + settings.x ] += direction[ 3 ];
		this.addPath( settings.x, settings.y, direction[ 2 ] );
		this.addPath( direction[ 0 ] + settings.x, direction[ 1 ] + settings.y, direction[ 3 ] );

		this.loop();

	},


	/**
	 *
	 */
	createTiles: function() {

		for ( let y = 0; y < settings.height; y++ ) {
			for ( let x = 0; x < settings.width; x++ ) {

				this.tiles[ y ][ x ] = this.getTileImage( x, y ) - 1;

			}
		}

		return this.tiles;

	},


	/**
	 * Draw the specified tile.
	 *
	 * @param {number} x X position of tile to draw.
	 * @param {number} y Y position of tile to draw.
	 */
	drawTile: function( x, y ) {

		let id = this.tiles[ y ][ x ] + 1;

		let sSize = settings.tileWidth;

		/**
		 * 5 is the number of tiles wide
		 */
		let imageX = ( id - 1 ) % 5;
		let imageY = Math.floor( ( id - 1 ) / 5 );

		// The clipping coordinates.
		let sx = imageX * sSize;
		let sy = imageY * sSize;

		this.ctx.drawImage( this.tileImage, sx, sy, sSize, sSize, x * sSize, y * sSize, sSize, sSize );

	},


	/**
	 * Loop through all the tiles and draw them.
	 */
	draw: function() {

		this.createTiles();

		for ( let y = 0; y < settings.height; y++ ) {
			for ( let x = 0; x < settings.width; x++ ) {

				this.drawTile( x, y );

			}
		}

	},


	/**
	 *
	 */
	getTileImage: function( x, y ) {

		// Default. A random dirt patch.
		let tile = this.defaultTile;
		let index = this.map[ y ][ x ];

		if ( y === 0 && index !== this.defaultTile ) {
			index = 64;
		}

		if ( y === settings.height - 1 && index !== this.defaultTile ) {
			index = 128;
		}

		switch ( index ) {

			// Horizontal road.
			case 6:
				tile = 2;

				if ( rando.percent( 30 ) ) {
					tile = 3;
				}

				break;

			// Vertical road.
			case 24:
				tile = 14;

				if ( rando.percent( 30 ) ) {
					tile = 19;
				}

				break;

			// Island.
			case 0:	// This covers any unreachable tiles.
			case 32:
				tile = 5;

				if ( rando.percent( 40 ) ) {
					tile = 10;
				}

				if ( rando.percent( 30 ) ) {
					tile = 15;
				}

				if ( rando.percent( 20 ) ) {
					tile = 20;
				}

				if ( rando.percent( 5 ) ) {
					tile = 25;
				}

				break;

			default:

				if ( this.tileLookup[ index ] ) {
					tile = this.tileLookup[ index ];
				} else {
					// console.log( this.map[ y ][ x ] );
				}

		}

		return tile;

	}

};